export default __webpack_public_path__ + "static/media/Session.b3efd3d8.svg";